<template>
  <div class="home">
    <!-- 首页 -->
    <div class="top" ref="top">
      <top-box></top-box>
    </div>
    <div class="main">
      <div class="item1 heart">
        <div class="tit">
          <img src="@/assets/item-backg.png" class="img" />
          <h3>产品概述</h3>
        </div>
        <div class="content">
          <div class="left">
            <img :src="item1[active].img" alt />
          </div>
          <div class="rigth">
            <div class="top">
              <span>{{ item1[active].title }}</span>
            </div>
            <p>{{ item1[active].text }}</p>
            <div class="btn" @click="item1Go(active)">
              <span>查看详情</span>
              <div></div>
            </div>

            <div class="page">
              <div class="left">
                <span>{{ active + 1 }}</span>
                <span>/{{ item1.length }}</span>
              </div>
              <div class="right">
                <div class="toLeft" @click="toggle(1)"></div>
                <div class="toRight" @click="toggle(2)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item2">
        <div class="heart">
          <div class="tit">
            <img src="@/assets/item-backg.png" class="img" />
            <h3>星火·链网赋能</h3>
          </div>
          <div class="content">
            <div class="item">
              <div class="item-box">
                <div class="title">
                  <img src="@/assets/home/standing.png" style="z-index: 1" />
                  <img src="@/assets/home/01.png" />
                  <span>数字身份标识</span>
                </div>
                <p>
                  采用星火
                  ·链网提供的服务，进行数字身份标识，为每一个碳账户主体，分配一个BID
                </p>
              </div>
            </div>
            <img src="../../assets/home/straightLine.png" class="strLine" alt />
            <div class="item">
              <div>
                <div class="title">
                  <img src="@/assets/home/assets.png" />
                  <img src="@/assets/home/02.png" />
                  <span>碳资产存储与保护</span>
                </div>
                <p>
                  企业端的碳排放权、碳配额、碳汇资产上链存储，受星火
                  ·链网的安全机制保护。
                </p>
              </div>
            </div>
            <img src="../../assets/home/straightLine.png" class="strLine" alt />
            <div class="item">
              <div>
                <div class="title">
                  <img src="@/assets/home/Trading.png" />
                  <img src="@/assets/home/03.png" />
                  <span>碳交易</span>
                </div>
                <p>
                  采用星火
                  ·链网的智能合约技术，能提高企业之间碳交易的效率，保证碳交易的安全。
                </p>
              </div>
            </div>
            <img src="../../assets/home/straightLine.png" class="strLine" alt />
            <div class="item">
              <div>
                <div class="title">
                  <img src="@/assets/home/Trading2.png" />
                  <img src="@/assets/home/04.png" />
                  <span>核算/核证过程溯源</span>
                </div>
                <p>
                  利用区块链技术，对碳排及产品碳足迹的核算/核证过程与结果进行溯源，保证数据的真实性和有效性。
                </p>
              </div>
            </div>
            <img src="../../assets/home/straightLine.png" class="strLine" alt />
            <div class="item">
              <div>
                <div class="title">
                  <img src="@/assets/home/keepOnRecord.png" />
                  <img src="@/assets/home/05.png" />
                  <span>存证</span>
                </div>
                <p>
                  碳排核证结果、产品碳足迹的认证结果，利用星火
                  ·链网的存证服务，有效保证了企业的双碳认证权益。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item3">
        <div class="heart">
          <div class="tit">
            <img src="@/assets/item-backg.png" class="img" />
            <h3>解决方案</h3>
          </div>
          <div class="content">
            <div class="item" v-for="(item, i) in item3" :key="item.text">
              <img :src="item.img" />
              <div class="diolg">
                <div>0{{ i + 1 }}/</div>
                <div class="masking">{{ item.masking }}</div>
              </div>
              <div class="text-box">
                <span>{{ item.text }}</span>
                <div @click="go(i + 1)">
                  <span>了解详情</span>
                  <img src="@/assets/arrow-s.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item4">
        <div class="heart">
          <div class="tit">
            <img src="@/assets/item-backg.png" class="img" />
            <h3>合作伙伴</h3>
          </div>
          <div class="content">
            <img src="@/assets/home/item4-1s.png" />
            <img src="@/assets/home/item4-2s.png" />
            <img src="@/assets/home/item4-3s.png" />
            <img src="@/assets/home/item4-4s.png" />
            <img src="@/assets/home/item4-5s.png" />
            <img src="@/assets/home/item4-6s.png" />
            <img src="@/assets/home/item4-7s.png" />
            <img src="@/assets/home/item4-8s.png" />
            <img src="@/assets/home/item4-9s.png" />
            <img src="@/assets/home/item4-10s.png" />
          </div>
          <!-- <div class="arrow">
            <img src="@/assets/arrow-left.png" alt @click="item4Go(1)" />
            <div></div>
            <img src="@/assets/arrow-right.png" alt @click="item4Go(2)" />
          </div>-->
        </div>
      </div>

      <div class="item5">
        <div class="heart">
          <div class="tit">
            <img src="@/assets/item-backg.png" class="img" />
            <h3>联系我们</h3>
          </div>
          <div class="content">
            <div class="left">
              <div class="box1">
                <img src="@/assets/home/item5-3.png" alt />
                <div class="text">
                  <span>商务合作</span>
                  <div>
                    <div class="text-left">
                      <img src="@/assets/home/user.png" alt />
                      <span>王女士</span>
                    </div>
                    <div class="text-rigth">
                      <img src="@/assets/home/phone.png" alt />
                      <span>131 4699 6030</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box1">
                <img src="@/assets/home/item5-4.svg" alt />
                <div class="text">
                  <span>业务咨询</span>
                  <div>
                    <div class="text-left">
                      <img src="@/assets/home/user.png" alt />
                      <span>王先生</span>
                    </div>
                    <div class="text-rigth">
                      <img src="@/assets/home/phone.png" alt />
                      <span>199 2339 4477</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rigth">
              <img src="@/assets/home/joinback.png" alt />
              <img src="@/assets/aboutUs/Marking.png" class="img1" />
              <div>重庆渝北区两江数字经济产业园9栋12楼</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-div">
      <div class="code-div">
        <img src="@/assets/home/code-icon.png" style="display: block" />
        <img src="@/assets/website.png" class="qr-code" />
      </div>

      <img
        src="@/assets/home/top-icon.png"
        style="margin-top: -10px; display: block"
        @click="scrllo"
      />
    </div>
  </div>
</template>

<script>
import TopBox from "./components/top.vue";
import img1 from "@/assets/home/item3-1.svg";
import img2 from "@/assets/home/item3-2.png";
import img3 from "@/assets/home/item3-3.png";
import img4 from "@/assets/home/item3-4.png";
import item1 from "@/assets/home/product.png";
import item2 from "@/assets/home/home.png";
export default {
  components: { TopBox },
  data() {
    return {
      active: 0,
      item3: [
        {
          img: img1,
          text: "零碳城市",
          masking: "基于星火·链网,建立零碳城市大脑,实现零碳城市",
        },
        {
          img: img2,
          text: "产业碳足迹",
          masking:
            "以“星火·链网”赋能，以链网协同为技术手段，打造汽车制业行业的碳足迹管理平台",
        },
        {
          img: img3,
          text: "零碳园区",
          masking:
            "协助园区实施能碳管理，并提供全面的能源数据和碳排放核算服务。",
        },
        {
          img: img4,
          text: "智慧能碳监管",
          masking:
            "分析能源消耗和碳排放的现状，制定和实施针对性的能耗减碳策略，为管理决策提供支持",
        },
      ],
      item1: [
        {
          title: "数智双碳平台",
          img: item1,
          text: "亿链纵横积极响应国家双碳目标战略，运用区块链、大数据、人工智能(AI)等前沿科技，推出 “亿碳通”双碳生态链综合服务平台，建立企业、政府及个人碳账户/碳账本，提供企业碳排、碳汇核算服务，协助政府实施碳监管，接入第三方碳核证机构，为整个双碳事业的各生态环节提供全方位服务。同时，依托标准化的“碳网关”技术，对接碳排放权交易中心与绿色金融机构，实现碳交易、碳金融的一站式服务。帮助企业及政府部门摸清“碳家底”，量化碳资产，规范碳生态，促进碳交易，对国家双碳目标战略具有重要推动作用。",
        },
        {
          title: "基于星火·链网的产业碳足迹平台",
          img: item2,
          text: "产业碳足迹管理平台，服务于我国各行各业，立足于我国数字经济大发展、绿色经济转型的时代背景，应用区块链、大数据、人工智能等技术，以国家新型基础设施“星火·链网”赋能，以链网协同为技术手段，打造各行业的碳足迹管理平台，建设产业碳足迹大数据中心，促进各行业全产业链节能减排，保持绿色健康发展，提升产品的国际竞争力，打破因碳关税形成的贸易壁垒，助力国家碳中和战略目标落地。",
        },
      ],
    };
  },
  mounted() {
    this.updateTitle();

    document
      .querySelector(".code-div")
      .addEventListener("mouseenter", function () {
        document.querySelector(".qr-code").style.display = "block";
      });
    document
      .querySelector(".code-div")
      .addEventListener("mouseleave", function () {
        document.querySelector(".qr-code").style.display = "none";
      });
  },

  methods: {
    updateTitle() {
      document.title = this.$route.meta.title; // 将 dynamicTitle 替换为你要设置的动态标题
    },

    item1Go(type) {
      if (type == 0) {
        this.$router.push("/numeracy");
      } else if (type == 1) {
        this.$router.push("/carbonFootprint");
      }
    },
    item4Go(type) {
      if (type) {
        console.log("left");
      } else {
        console.log("right");
      }
    },
    toggle(type) {
      if (type == 1) {
        this.active--;
        if (this.active < 0) {
          this.active = this.item1.length - 1;
        }
        console.log(this.active);
      } else {
        this.active++;
        if (this.active > this.item1.length - 1) {
          this.active = 0;
        }
      }
    },
    go(type) {
      if (type == 1) {
        this.$router.push("/zeroCarbonCity");
      } else if (type == 2) {
        this.$router.push("/IndustrialCarbon");
      } else if (type == 3) {
        this.$router.push("/zeroCarbonPark");
      } else if (type == 4) {
        this.$router.push("/energyConsumption");
      }
    },
    scrllo() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.heart {
  width: 1400px;
  margin: 0 auto;
}
.home {
  width: 100%;
  box-sizing: border-box;
  .top {
    width: 100%;
    height: 600px;
    box-sizing: border-box;
  }
  .main {
    width: 100%;
    .item1 {
      margin-top: 52px;
      margin-bottom: 52px;
      height: 505px;
      background: radial-gradient(
        circle at center,
        rgba(213, 223, 216, 0.2),
        rgba(255, 255, 255, 0)
      );
      border-radius: 32px;
      > .tit {
        position: relative;
        padding-top: 30px;
        .img {
          position: absolute;
          left: 50%;
          transform: translate(-200%, -22%);
        }
        h3 {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
          text-align: center;
        }
      }
      .content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
        > .left {
          width: 680px;
          height: 348px;
          margin-right: 38px;
          margin-left: 24px;
          img {
            width: 651px;
            height: 349px;
            margin: 0 auto;
          }
        }
        > .rigth {
          width: 652px;
          height: 323px;
          display: flex;
          margin-top: 57px;
          flex-direction: column;
          position: relative;
          .top {
            height: 33px;
            span {
              font-size: 24px;
              font-family: PingFangSC-Light, PingFang SC;
              color: #333333;
              font-weight: bold;
              line-height: 33px;
            }
            .s1 {
              font-weight: bold;
            }
          }
          > p {
            text-indent: 2em;
            margin-top: 32px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            margin-right: 24px;
          }
          .btn {
            margin-top: 62px;
            width: 126px;
            height: 34px;
            font-size: 16px;
            border: 1px solid #222124;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            div {
              width: 14px;
              height: 11px;
              background-image: url("@/assets/arrow.png");
              background-size: cover;
              margin-left: 8px;
            }
          }
          .btn:hover {
            border: none;
            background-color: #00dd62;
            color: #ffffff;
            div {
              background-image: url("@/assets/arrow-s.png");
            }
          }
          .page {
            display: flex;
            position: absolute;
            right: 23px;
            bottom: 0;
            .left {
              margin-right: 21px;
              span {
                font-size: 24px;
                font-family: D-DIN-PRO-Medium, D-DIN-PRO;

                color: #222124;
                line-height: 29px;
                margin-right: 4px;
              }
                span:nth-child(1){
					font-weight:bold;
                }
              span:nth-child(2) {
                color: #d5dfd8;
                margin-right: 0px;
              }
            }
            .right {
              display: flex;
              div {
                cursor: pointer;
              }
              .toLeft:hover {
                background: url("@/assets/theSolution/item5-1.png");
                background-repeat: no-repeat;
                transform: rotate(0deg);
              }
              .toLeft {
                width: 30px;
                height: 30px;
                background: url("@/assets/theSolution/item5-2.png");
                transform: rotate(180deg);
              }
              .toRight {
                width: 30px;
                height: 30px;
                background: url("@/assets/theSolution/item5-2.png");
                margin-left: 8px;
              }
              .toRight:hover {
                background: url("@/assets/theSolution/item5-1.png");
                transform: rotate(180deg);
                background-repeat: no-repeat;
              }
            }
          }
        }
      }
    }
    .item2 {
      margin-top: 52px;
      height: 505px;
      background: #fafbfa;
      padding-top: 68px;
      box-sizing: border-box;
      .tit {
        position: relative;
        > .img {
          position: absolute;
          left: 50%;
          transform: translate(-274%, -22%);
        }
        h3 {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
          text-align: center;
        }
      }
      .content {
        display: flex;
        .item {
          height: 266px;
          width: 268px;
          margin-top: 68px;

          .title {
            height: 50px;
            width: 100%;
            position: relative;
            img {
              bottom: 0;
              left: 0;
              position: absolute;
              &:nth-child(1) {
                z-index: 1;
              }
            }
            span {
              position: absolute;
              bottom: 0px;
              left: 36px;
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #333333;
              line-height: 28px;
            }
          }
          p {
            margin-top: 16px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 18px;
          }
        }
        .item:nth-of-type(2n) {
          display: flex;
          align-items: end;
        }
        .strLine:nth-of-type(2n) {
          transform: rotate(180deg);
        }
        .strLine {
          margin: 68px 6px 0px;
          height: 260px;
        }
      }
    }
    .item3 {
      margin-top: 60px;
      box-sizing: border-box;
      padding-bottom: 60px;
      .tit {
        position: relative;
        > .img {
          position: absolute;
          left: 50%;
          transform: translate(-200%, -22%);
        }
        h3 {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
          text-align: center;
        }
      }
      .content {
        margin-top: 48px;
        display: flex;
        .item:hover .diolg {
          display: flex;
        }
        .item {
          width: 344px;
          height: 400px;
          display: flex;
          margin-right: 8px;
          flex-direction: column;
          position: relative;
          .diolg {
            width: 344px;
            height: 314px;
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(34, 33, 36, 0.75);
            border-radius: 4px 4px 0px 0px;
            display: flex;
            flex-direction: column;
            padding-top: 24px;
            box-sizing: border-box;
            display: none;
            > div {
              margin-left: 24px;
              font-size: 60px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: rgba(213, 223, 216, 0.5);
              line-height: 40px;
            }
            > .masking {
              flex: 1;
              width: 200px;
              margin: auto;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              display: flex;
              line-height: 22px;
              justify-content: center;
              align-items: center;
              transform: translateY(-10%);
            }
          }
          > img {
            width: 344px;
            height: 314px;
            border-bottom: 2px solid #00dd62;
          }
          > .text-box {
            display: flex;
            padding: 0px 24px;
            box-sizing: border-box;
            align-items: center;
            justify-content: space-between;
            width: 344px;
            height: 86px;
            background: #ffffff;
            box-shadow: 0px 0px 15px 0px #eff2ef;
            border-radius: 0px 0px 4px 4px;
            > span {
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #333333;
              line-height: 20px;
            }
            > div:hover {
              background: #00dd62;
            }
            > div {
              width: 106px;
              height: 28px;
              background: #333333;
              border-radius: 2px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              > span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 20px;
              }
              img {
                margin-left: 8px;
              }
            }
          }
        }
      }
    }
    .item4 {
      box-sizing: border-box;
      background: #fafbfa;
      padding-bottom: 60px;
      padding-top: 41px;
      .tit {
        position: relative;
        > .img {
          position: absolute;
          left: 50%;
          transform: translate(-200%, -22%);
        }
        h3 {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
          text-align: center;
        }
      }
      .content {
        margin-top: 48px;
        display: flex;
        flex-wrap: wrap;
        img {
          width: 273px;
          height: 88px;
          margin-right: 8px;
          margin-top: 16px;
        }
        img:nth-child(5n) {
          margin-right: 0px;
        }
      }
      .arrow {
        display: flex;
        justify-content: center;
        margin-top: 60px;
        div {
          width: 1px;
          height: 10px;
          background-color: #d5dfd8;
          margin: 0px 23px;
        }
        img {
          cursor: pointer;
        }
      }
    }

    .item5 {
      box-sizing: border-box;
      padding-bottom: 52px;
      padding-top: 41px;
      .tit {
        position: relative;
        > .img {
          position: absolute;
          left: 50%;
          transform: translate(-200%, -22%);
        }
        h3 {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          line-height: 32px;
          text-align: center;
        }
      }
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 300px;
        margin-top: 33px;
        .left {
          width: 500px;
          height: 100%;
          display: flex;
          background: #fafbfa;
          border-radius: 0px 4px 4px 0px;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .box1 {
            width: 345px;
            height: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 101px;
              height: 101px;
            }
            .text {
              margin-left: 15px;

              flex: 1;
              span {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #333333;
              }
              > div {
                margin-top: 25px;
                width: 100%;
                display: flex;
                img {
                  width: 18px;
                  height: 18px;
                  margin: 0px 4px 0px 0px;
                }
                .text-left {
                  display: flex;
                  span {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 16px;
                  }
                }
                .text-rigth {
                  margin-left: 20px;
                  font-size: 16px;
                  font-family: D-DIN-PRO-Medium, D-DIN-PRO;
                  font-weight: 600;
                  color: #333333;
                }
              }
            }
          }
          .box1:nth-child(2) {
            margin-top: 22px;
          }
        }
        .rigth {
          width: 900px;
          height: 300px;
          position: relative;
          img {
            width: 900px;
            height: 300px;
          }
          .img1 {
            width: 23px;
            height: 28px;
            position: absolute;
            top: 98px;
            right: 356px;
          }
          div {
            width: 324px;
            height: 74px;
            position: absolute;
            display: flex;
            top: 32px;
            right: 200px;
            justify-content: center;
            align-items: center;
            background: url("@/assets/aboutUs/item2back.png");
            background-size: cover;
            background-position: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }
    }
  }
  .fixed-div {
    position: fixed;
    right: 1.5%;
    bottom: 20px;
    .code-div {
      width: 68px;
      height: 68px;
      position: relative;
      .qr-code {
        position: absolute;
        display: none;
        top: 0;
        right: 68px;
      }
    }
  }
}
</style>
